// Returns the parsed JSON body, or {} on failure so callers can safely check fields like `success`.
const _checkResponse = async (response) => {
  if (response.status === 401 || response.status === 403) {
    window.location.href = '/app/logout';
    return {};
  }
  if (response.ok) {
    return response.json();
  }
  console.log("Network error, got response code " + response.status);
  alert("The application has encountered a problem. Please try again later");
  return {};
};

const _request = async (url, options = {}) => {
  const response = await fetch('/app' + url, { credentials: "include", ...options });
  return _checkResponse(response);
};

const doGet = (url) => _request(url);

const doPost = (url, params) => _request(url, { method: "POST", body: JSON.stringify(params) });

const doPut = (url, params) => _request(url, { method: "PUT", body: JSON.stringify(params) });

const doFormPost = (url, form) => _request(url, { method: "POST", body: new FormData(form) });

export default doGet;
export {doPost, doGet, doPut, doFormPost};
